export default __webpack_public_path__ + "static/media/clients_l.efdb6ab6.jpg";